module.exports = __webpack_public_path__ + "static/media/no-profile-image.740eac0c.png";